import { prefix as prefixBase } from '../constants'
export const prefix = `${prefixBase}.form`
export const prefixButtons = `${prefixBase}.buttons`
